export default "__VITE_ASSET__a457bf5c__"